export const FETCH_PHOTOS = Object.freeze({
    INITIAL: "INITIAL",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE"
});
